const pageStatus = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
  INVALID: "invalid",
};

export default pageStatus;
